import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/browser'
import './index.css'
import * as serviceWorker from './serviceWorker'
import { Routers } from './Routers'
import {checkInAB} from "./utils"
// import './mock/index'

Sentry.init({
  dsn: "https://7930c1c618bf497ca7af9aecdc5d4586@sentry-relay.tantanapp.com/20",
  environment: process.env.REACT_APP_NODE_ENV,
  release: process.env.REACT_APP_RELEASE_VERSION,
  sampleRate: 1,
});

/** 添加全局doWhenGetToken方法, 旧安卓版本调用 **/
(window as any).doWhenGetToken = () => { }

(async () => {
  window['mytantanH5-gloable-inAB'] = await checkInAB('REV_newmytantan:exp')
  ReactDOM.render(
    <Routers />
    , document.getElementById('root'))
})()


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
